import { CopyButton, HeadItemType, Table } from 'components'
import { DraftProps } from 'container/Home/components/Banners/interface'
import { Dispatch, SetStateAction, useState } from 'react'
import { URL_CONST } from 'constants/urls'
import * as S from './styles'
import ModalDuplicate from 'container/SalesOrder/components/ModalDuplicate'
import ModalPostOn, {
  ClientsListInterface
} from 'container/SalesOrder/components/ModalPostOn'
import { useDispatch, useSelector } from 'store/store'
import { toast } from 'react-toastify'
import {
  setCheckedRecords,
  setDuplicateOrder
} from 'store/SalesOrderContext/salesOrderSlice'
import * as DraftOV from 'services/draft'
import { useNavigate } from 'react-router-dom'
import { FormatBodyType, getPostOnBody } from 'container/ManageOrders/utils'
import SalesOrderMenu from '../ViewBySalesOrder/SalesOrderMenu'
import CheckedDraftVerification from '../ViewBySalesOrder/CheckedDraftVerification'

type ViewByOrderAnticipationProps = {
  setDraftsData: Dispatch<SetStateAction<DraftProps[]>>
  draftsData: DraftProps[]
  getOrdersData: (body?: FormatBodyType) => Promise<void>
  draftsPage: number
}

const ViewByOrderAnticipation = ({
  setDraftsData,
  getOrdersData,
  draftsData,
  draftsPage
}: ViewByOrderAnticipationProps) => {
  const dispatch = useDispatch()
  const { draftBody, duplicateOrder } = useSelector(({ salesOrder }) => salesOrder)
  const [modalPostOn, setModalPostOn] = useState(false)
  const [modalDuplicate, setModalDuplicate] = useState(false)
  const [selectedOrderAnticipation, setSelectedOrderAnticipation] = useState('')
  const navigate = useNavigate()

  const setOrderAnticipationSelection = (checked: boolean, id?: string) => {
    if (id) {
      const nrPedido = id.split('+')[0]

      const updatedData = draftsData.map((orderAnt) =>
        orderAnt.NumeroPedidoRascunho === nrPedido ? { ...orderAnt, checked } : orderAnt
      )
      setDraftsData(updatedData)
    } else {
      const updatedData = draftsData.map((orderAnt) => ({ ...orderAnt, checked }))
      setDraftsData(updatedData)
    }
  }

  const headTable: HeadItemType[] = [
    {
      label: 'Nº de Pedido no Portal',
      columnName: 'NumeroPedidoPortal'
    },
    {
      label: 'Razão social',
      columnName: 'RazaoSocial'
    },
    {
      label: '',
      columnName: ''
    },
    {
      label: '',
      columnName: ''
    },
    {
      label: 'Saldo Atendido',
      columnName: 'SaldoAtendido'
    },
    {
      label: 'Mat. Aberto',
      columnName: 'MatAberto'
    },
    {
      label: '',
      columnName: ''
    }
  ]

  const closePostOn = () => {
    setModalPostOn(false)
  }

  const handlePostOn = async (array: ClientsListInterface[]) => {
    const body = getPostOnBody(array, draftBody, selectedOrderAnticipation)

    const post = await DraftOV.duplicateDraftOV(body)

    if (post) {
      closePostOn()
      getOrdersData({ page: draftsPage })
    }
    dispatch(setCheckedRecords([]))
  }

  const handleDuplicateOrder = async () => {
    await DraftOV.duplicateDraftOV(duplicateOrder).then((response) => {
      if (response) {
        navigate(`${URL_CONST.ORDERS}/${response[0]?.NumeroPedido?.trim()}`)
        window.location.reload()
      } else {
        toast.error('Erro ao duplicar pedido.')
      }
    })

    setDuplicateOrder({ ...duplicateOrder, Clientes: [] })
  }

  return (
    <>
      <CheckedDraftVerification
        draftsData={draftsData}
        getOrdersData={getOrdersData}
        draftsPage={draftsPage}
      />
      <Table
        hasCheckbox
        setChecked={setOrderAnticipationSelection}
        headData={headTable}
        bodyData={draftsData.map((orderAnt) => {
          return {
            id: `${orderAnt.NumeroPedidoRascunho}`,
            checked: orderAnt.checked,
            linkNavigate: `${URL_CONST.MANAGE_ORDER}/${orderAnt.NumeroPedidoRascunho}`,
            statusOrder: orderAnt.CodigoStatusPedido,
            colunsNotNavigate: [6],
            content: [
              <S.TableInfo key={`number-${orderAnt.NumeroPedidoRascunho}`}>
                <S.Flex>
                  {orderAnt.NumeroPedidoRascunho}
                  <CopyButton text={orderAnt.NumeroPedidoRascunho} />
                </S.Flex>
                <span>Solicitado em {orderAnt.DataCriacaoPedido}</span>
              </S.TableInfo>,
              <S.TableInfo key={`client-${orderAnt.NumeroPedidoRascunho}`}>
                {orderAnt.NomeCliente}
                <span>Código SAP: {orderAnt.CodigoCliente}</span>
              </S.TableInfo>,
              <></>,
              <></>,
              orderAnt.QuantidadeTotalAtendida,
              orderAnt.QuantidadeTotalNaoAtendida,
              <SalesOrderMenu
                key={`action-more-${orderAnt.NumeroPedidoRascunho}`}
                draft={orderAnt}
                getOrdersData={getOrdersData}
                draftsPage={draftsPage}
                setSelectedDraft={setSelectedOrderAnticipation}
                selectedDraft={selectedOrderAnticipation}
                setModalDuplicate={setModalDuplicate}
                setModalPostOn={setModalPostOn}
                modalDuplicate={modalDuplicate}
              />
            ]
          }
        })}
      />
      <ModalPostOn
        open={modalPostOn}
        setOpen={setModalPostOn}
        orderNumber={selectedOrderAnticipation}
        handlePostOn={handlePostOn}
        handleCancel={closePostOn}
      />
      {duplicateOrder?.nr_pedi_rasc_orig && (
        <ModalDuplicate
          open={modalDuplicate}
          setOpen={() => setModalDuplicate(!modalDuplicate)}
          handleDuplicated={handleDuplicateOrder}
        />
      )}
    </>
  )
}

export default ViewByOrderAnticipation
